import React from 'react';

import { Booking, BookingConstraints } from '../../model/Booking';

import {Item} from './Item';

import Flex from '../StyledComponents/Flex';
import {isNullOrUndefined} from "../../utils";
import {useTranslation} from "@nic-react-i18n/core";
// import Test from '../../model/Test';
// import RestrictionsView from './RestrictionsView';

interface DetailsViewInterface {
    restrictions?: BookingConstraints;
    booking: Booking;
}

type DetailsViewProps = DetailsViewInterface;

const algorithmNameById = {
    '3': 'DSA/SHA-1',
    '5': 'RSA/SHA-1',
    '6': 'DSA-NSEC3-SHA1',
    '7': 'RSASHA1-NSEC3-SHA1',
    '8': 'RSA/SHA-256',
    '10': 'RSA/SHA-512',
    '12': 'ECC-GOST',
    '13': 'ECDSAP256SHA256',
    '14': 'ECDSAP384SHA384'
};

const getAlgById = (restrictions: BookingConstraints | undefined): string => {
    let res: string = '';

    if (!isNullOrUndefined(restrictions)) {
        if (!isNullOrUndefined((algorithmNameById as any)[restrictions?.dnsSecAlg??0])) {
            res = `${restrictions?.dnsSecAlg} - [${(algorithmNameById as any)[restrictions?.dnsSecAlg??0]}]`;
        } else {
            res = `3 - [${algorithmNameById['3']}]`;
        }
    } else {
        res = `3 - [${algorithmNameById['3']}]`;
    }
    return res;
};

 const DetailsView: React.FC<DetailsViewProps> = (props: DetailsViewProps) => {
    const {restrictions,  booking} = props;
    const {t} = useTranslation()
    let hasConstraints = (!isNullOrUndefined(restrictions));
    return (
        <div>
            <div>
                <Flex
                    direction={'row'}
                    justify={'flex-start'}
                    align={'center'}
                >
                    <div style={{fontSize: '1.8rem', color: 'gray', marginRight: '20px'}}>
                        <i className={'fas fa-server'} />
                    </div>
                    <div>
                        <Item
                            label={t('test.server')}
                            value={booking.serverName}
                        />
                    </div>
                </Flex>
            </div>
            {hasConstraints &&
                <div>
                    <div>
                        <Flex
                            direction={'row'}
                            justify={'flex-start'}
                            align={'center'}
                        >
                            <div style={{fontSize: '1.8rem', color: 'gray', marginRight: '20px'}}>
                                <i className={'fas fa-key'} />
                            </div>
                            <Item
                                label={t('restrictions.algorithm')}
                                value={getAlgById(restrictions)}
                            />
                        </Flex>
                    </div>
                    <div>
                        <Flex
                            direction={'row'}
                            justify={'flex-start'}
                            align={'center'}
                        >
                            <div style={{fontSize: '1.8rem', color: 'gray', marginRight: '20px'}}>
                                <i className={'fas fa-globe'} />
                            </div>
                            <Item
                                label={t('restrictions.domain')}
                                value={ restrictions?.domain ?? ''}
                            />
                        </Flex>
                    </div>
                </div>
            }

        </div>
    )
}
export default DetailsView